import React from 'react';
import { handleTrack } from '../../../utils/tracker';
import { Button, ButtonVariants } from '../../Atoms/Button';
import { FirstFoldHeroCardData } from '../types';

const HeroCard: React.FC<FirstFoldHeroCardData> = ({
  href,
  trackingLabel,
  hoverText,
  hoverId,
  backgroundGradient,
  iconSrc,
  iconAlt,
  title,
  subtitle,
  buttonText,
}) => {
  const handleHeroCardClick = (event: React.MouseEvent) => {
    handleTrack({
      label: trackingLabel,
      obj: event.target,
    });
  };

  return (
    <a
      href={href}
      target="_blank"
      onClick={handleHeroCardClick}
      className="relative z-20 group"
      rel="noreferrer"
    >
      <div className="bg-white border-2 border-transparent rounded-3xl shadow-lg hover:border-indigo-500 transition-all duration-500 w-72 lg:w-56 md:w-48 sm:w-40 max-w-[280px]">
        {/* Hover div */}
        <div
          className="absolute -top-5 lg:w-56 md:w-48 sm:w-40 h-36 bg-indigo-500 w-full text-white font-semibold text-sm rounded-3xl text-center pt-1 opacity-0 group-hover:opacity-100 group-hover:-translate-y-1 transition-all duration-500 z-[-10] hidden xl:block lg:block left-0"
          id={hoverId}
        >
          {hoverText}
        </div>
        <div
          className="p-6 lg:p-5 md:p-4 sm:p-4 rounded-3xl"
          style={{
            background: backgroundGradient,
          }}
        >
          <img src={iconSrc} className="pb-3 sm:h-8" alt={iconAlt} />
          <div className="font-bold text-2xl text-font-500 sm:text-sm lg:text-xl md:text-base mb-2">
            {title}
          </div>
          <div className="font-medium text-xl text-font-200 mb-6 sm:text-sm lg:text-base md:text-sm">
            {subtitle}
          </div>
          <div className="mt-6 sm:mt-3">
            <Button
              variant={ButtonVariants.bluefilled}
              rounded="md"
              className="w-full text-center text-base sm:text-sm"
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </a>
  );
};

export default HeroCard;
